module.exports = __webpack_public_path__ + "img/cedula-profesional.59fd1e18.png";